import store from '@/store'
import moment from 'moment'
import { getCookie } from '@/utils/auth'

const fn = (err, type = 0, data = {}) => { 
    const userInfos = store?.state?.user.userInfos;
    let tenantId = '';
    let userName = '';
    let userId = '';
    const operateTime = moment().format("YYYY-MM-DD HH:mm:ss");
    const token = getCookie('dhr-Token');
    const remark = {
        error: err.message,
        href: window.location.href,
        ...data
    }

    if (userInfos && userInfos.accountId) {
        tenantId = userInfos.accountId;
        userName = userInfos.cnName;
        userId = userInfos.loginUserId;
    }
    
    const params = {
        operateTime,
        remark: JSON.stringify(remark),
        tenantId,
        token,
        type,
        userId,
        userName
    }
    return params;
}


export default fn